import { Navigate, useLocation, useParams } from 'react-router'

const LegacyGroupsRedirect = () => {
  const { slug } = useParams<{ slug: string }>()
  const { search } = useLocation()

  return (
    <Navigate replace to={{ pathname: `/games/${slug}/map/groups`, search }} />
  )
}

export default LegacyGroupsRedirect
